import { render, staticRenderFns } from "./DefaultCardHeader.vue?vue&type=template&id=1bb661bc&"
import script from "./DefaultCardHeader.vue?vue&type=script&lang=js&"
export * from "./DefaultCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCardHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports